<script>
import appConfig from "@/app.config";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import satdosyafirma from "@/models/satdosyafirma";
import AddEdit from "../satdosyafirma/addedit.vue";
import satdosyafirmafiyat from "../satdosyafirmafiyat/addedit.vue";  
import piyasaarastirmatutanagi from "./piyasaarastirmatutanagi.vue";
import piyasaarastirmagorevlileri from "./piyasaarastirmagorevlileri.vue";
import yaklasikmaliyettenaktar from "./yaklasikmaliyettenaktar.vue";

export default {
  props: ["satdosyaId"],
  mixins: [apibtoast, apigeneric, satdosyafirma],
  page: {
    title: "Satın Alma Firmalar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    AddEdit,
    satdosyafirmafiyat, 
    piyasaarastirmatutanagi,
    piyasaarastirmagorevlileri,
    yaklasikmaliyettenaktar
  },
  data() {
    return {
      title: this.$t("satdosyafirma.Title"),
      items: [
        {
          text: this.$t("satdosyafirma.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("satdosyafirma.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("satdosyafirma.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      FirmaId: "",
      PiyasaFiyat: null,
      Piyasaarastirmagorevliler:"",
      PATStartup:0,
      SatDosya:null,
      Piyasaarastirmagorevlileri: "",
      Personeller: [],
      Yaklasikmaliyetdosyasi: null,
    };
  },
  methods: {
    Get() {
       this.ActionsFilterGet({"Service":"satdosyafirma", "Page":this.Page,"Filter":"&Dosyaid="+this.satdosyaId+"&Firmaturu=2"}).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.$emit("aktif_menu_title",this.$t('piyasaarastirmatutanagi.Title'));
      });
      
      this.ActionsSingleGet({ Service: "SatDosya", Id:  this.satdosyaId }).then((res) => {
        this.SatDosya = res.Data;
      });

      this.ActionsFilterGet({"Service":"satonaybelgesi", "Page":this.Page,"Filter":"&Dosyaid="+this.satdosyaId}).then((res) => {
        this.Piyasaarastirmagorevlileri = res.Data[0].Gorevliler;
        this.Personeller = [];
        for(var Personel in this.Piyasaarastirmagorevlileri){
      this.ActionsFilterGet({
          Service: "opersonel/GetAllPersonel",
          Page: this.Page,
          Filter:"&Id=" + this.Piyasaarastirmagorevlileri[Personel]
        }).then((res) => {
          this.Personeller.push(res.Data[0])
        })
      }
      });
    },
  },
  watch: {
    satdosyaId() {
      this.Get();
    },
  },
};
</script>

<template> 
  <div class="row">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-2">
            
            <div class="col-sm-12">
              <div class="text-sm-end"> 
                <button
                  type="button"
                  class="btn btn-primary btn-rounded mb-2 me-2"
                  v-b-modal.satdosyafirma
                  @click="(DataUpdate = satdosyafirmaData), (AddEdit = 'Add')"
                  v-if="!SatDosya.Tamamlandi && SatDosya.yaklasikmaaliyetbirimfiyat == true"
                >
                  <i class="mdi mdi-plus me-1"></i
                  >{{ $t("satdosyafirma.Page.YeniKayitEkle") }}
                </button> 
                <button
                  type="button"
                  class="btn btn-danger btn-rounded mb-2 me-2"
                  v-b-modal.yaklasikmaliyettenaktar
                  @click="(DataUpdate = satdosyafirmaData), (AddEdit = 'Add')"
                  v-if="!SatDosya.Tamamlandi && !SatDosya.yaklasikmaaliyetbirimfiyat"
                >
                  <i class="fas fa-angle-double-right"></i
                  > {{ $t("satdosyafirma.Page.YaklasikMaliyettenAktar") }}
                </button>
       <!--         <button
                  type="button"
                  class="btn btn-warning btn-rounded mb-2 me-2"
                  v-b-modal.piyasaarastirmagorevliler
                  @click="(DataUpdate = satdosyafirmaData), (AddEdit = 'Add')"
                > 
                      <i class="fas fa-user-plus"></i>
                   {{ $t("piyasaarastirmatutanagi.Page.piyasaarastirmagorevliler") }}
                </button>  -->
                <button
                  type="button"
                  class="btn btn-success btn-rounded mb-2 me-2"
                  v-b-modal.piyasaarastirmatutanagi
                  @click="(DataUpdate = satdosyafirmaData),  (PATStartup += 1), (Personeller = Personeller)"
                >
                      <i class="mdi mdi-file-export-outline me-1"></i>
                   {{ $t("satdosyafirma.Page.TeklifFiyatDegerlendirme") }}
                </button>
              </div>
            </div>
          </div>

          <div class="table-responsive"> 
            <table class="table mb-0">
              <thead class="table-light">
                <tr>
                  <th>{{ $t("satdosyafirma.Table.Firmaid") }}</th>
                  <th style="width: 85px; text-align: center;">{{ $t("satdosyafirma.Table.Islem") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="Data in TableData" :key="Data.Id">
                  <th scope="row">{{ Data.Firmaadi }}</th>
                  <td style="width: 85px; text-align: center;">
                    <b-button-group>
                          <b-button  @click="(FirmaId = Data.Id),(Firmaadi = Data.Firmaadi), (Yaklasikmaliyetdosyasi = Data.Yaklasikmaliyetdosyasi)" v-b-modal.satdosyafirmafiyat v-tooltip="$t('satdosyafirma.Table.FiyatTeklifleri')" variant="primary">
                            <i class="far fa-edit"></i>
                          </b-button>
                          <b-button  @click="Delete('satdosyafirma', Data.Id)" v-tooltip="$t('satdosyafirma.Table.Sil')" variant="danger">
                            <i class="far fa-trash-alt"></i>
                          </b-button>
                        </b-button-group>
                  
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <b-pagination
              class="pagination pagination-rounded justify-content-end mb-2"
              v-model="DefaultPage"
              :total-rows="Page.PageDataSize"
              :per-page="Page.PageSize"
              aria-controls="my-table"
              @input="ChangePage(DefaultPage)"
            >
            </b-pagination>
          </div>
          <piyasaarastirmagorevlileri  
            :satdosyaId="satdosyaId"
            :Tamamlandi="SatDosya.Tamamlandi"
          />
          <yaklasikmaliyettenaktar  
            :satdosyaId="satdosyaId" @TableUpdate="Get" :FirmasData = "TableData"
          />
          <piyasaarastirmatutanagi  
          :PATStartup="PATStartup" 
          v-if="PATStartup > 0"
          :Tamamlandi="SatDosya.Tamamlandi"
            :satdosyaId="satdosyaId"
            :Personeller ="Personeller"
          />
          <AddEdit
            v-if="AddEdit" 
            :Firmaturu="2"
            :FormData="DataUpdate"
            :AddEdit="AddEdit"
            :satdosyaId="satdosyaId"
            @TableUpdate="Get()"
          />
          <satdosyafirmafiyat v-if="FirmaId"
            :FirmaId="FirmaId"
            :Firmaadi="Firmaadi"
            :AddEdit="AddEdit"
            :satdosyaId="satdosyaId"
            :Fiyatturu=2
            :Yaklasikmaliyetdosyasi="Yaklasikmaliyetdosyasi"
          />
        </div>
      </div>
    </div>
  </div>
</template>
